import { PageCenter } from "@/lib/react/page-center/page-center";
import React from "react";

export const PageLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div
      style={{ width: "min(100%, 50em)", margin: "2em auto", padding: "1em" }}
    >
      {children}
    </div>
  );
};
